class Video {
  constructor() {
    const playbutton = Array.prototype.slice.call(document.querySelectorAll('.ns-video__playbutton'));
    playbutton.forEach(button => {
      button.addEventListener('click', () => {
        const video = button.parentElement.parentElement;
        const thumbnail = button.parentElement;
        const iframe = video.querySelector('iframe');
        iframe.src = iframe.src + '?autoplay=1';
        thumbnail.classList.add('fade-out');
        setTimeout(() => {
          thumbnail.style.display = 'none';
        }, 400);
      });
    });
  }
}


export default Video;

